export default __webpack_public_path__ + "static/media/counter-icon-1.e6228c7a.svg";